import { render, staticRenderFns } from "./AlertError.vue?vue&type=template&id=0244c148&"
import script from "./AlertError.vue?vue&type=script&lang=ts&"
export * from "./AlertError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports